var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLogout = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 8.66655C9.63125 8.66655 9.33328 8.96525 9.33328 9.33317V11.9999C9.33328 12.3672 9.03457 12.6665 8.66654 12.6665H6.66656V2.6666C6.66656 2.09727 6.30389 1.58861 5.75861 1.39928L5.56122 1.33324H8.66654C9.03457 1.33324 9.33328 1.63255 9.33328 1.99998V3.99996C9.33328 4.36788 9.63125 4.66658 9.9999 4.66658C10.3685 4.66658 10.6665 4.36788 10.6665 3.99996V1.99998C10.6665 0.897331 9.76919 0 8.66654 0H1.49998C1.47459 0 1.45335 0.0113525 1.4287 0.0146483C1.39659 0.0119628 1.36595 0 1.33336 0C0.598016 0 0 0.597895 0 1.33324V13.3331C0 13.9025 0.362667 14.4111 0.907949 14.6005L4.91999 15.9378C5.05598 15.9798 5.19123 15.9999 5.33332 15.9999C6.06866 15.9999 6.66656 15.4018 6.66656 14.6665V13.9999H8.66654C9.76919 13.9999 10.6665 13.1025 10.6665 11.9999V9.33317C10.6665 8.96525 10.3685 8.66655 9.9999 8.66655Z",
    fill: "#C5C7CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8045 6.19512L13.1378 3.52852C12.9472 3.33785 12.6605 3.28048 12.4112 3.38375C12.1626 3.48714 11.9998 3.73042 11.9998 3.99983V5.99981H9.33324C8.96521 5.99981 8.6665 6.29839 8.6665 6.66643C8.6665 7.03447 8.96521 7.33305 9.33324 7.33305H11.9998V9.33303C11.9998 9.60243 12.1626 9.84572 12.4112 9.94911C12.6605 10.0524 12.9472 9.99501 13.1378 9.80446L15.8045 7.13774C16.0651 6.87712 16.0651 6.45574 15.8045 6.19512Z",
    fill: "#C5C7CD"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logout.dc2f646a.svg";
export { ForwardRef as ReactComponent };